/**
 * operatingBarRoutes — Aug 2026
 * ================================================================
 * Extracted from `<OperatingCommandBar />` so it can be unit-tested
 * without pulling in axios / the API client (Jest's ESM boundary
 * chokes on axios' `import` syntax). Pure URL matcher used by the
 * bar's context-aware hiding logic.
 */

/**
 * @param {{ key: string }} item
 * @param {string} pathname   — react-router's `location.pathname`
 * @param {string} search     — react-router's `location.search`
 * @param {string|number|null|undefined} businessId
 * @returns {boolean} true when the ITEM points at the URL the founder is already on
 */
export function isCurrentOperatingRoute(item, pathname, search, businessId) {
  if (!item || !businessId) return false;
  switch (item.key) {
    case "cohort-pnl":
      return pathname === `/business/${businessId}/cohorts`;
    case "experiments":
      return pathname === `/business/${businessId}/experiments`;
    case "log-revenue":
      return pathname === `/business/${businessId}/log-actuals`;
    case "whats-due": {
      if (pathname !== "/compliance") return false;
      try {
        const p = new URLSearchParams(search || "");
        return p.get("business") === String(businessId);
      } catch {
        return false;
      }
    }
    default:
      return false;
  }
}
